import styled from "@emotion/styled";
import { LAYER_ONE, LAYER_TWO } from "constants/z-index";
export const StyledTagsAndAssetsComponent = styled.div`
  position: relative;

  .clickable-tags-grid {
    z-index: ${LAYER_TWO};
    position: absolute;
    top: calc(132 * (100vw / 1920));
    left: 0;
  }

  img {
    width: 100%;
    object-fit: contain;
    max-width: 900px;
  }

  .default-asset {
    opacity: 0;
    transition: opacity 0.3s ease-in-out;

    &.active {
      opacity: 1;
    }
  }

  .assets-container {
    z-index: ${LAYER_ONE};
    position: relative;
    margin-left: 10vw;

    .picture-wrapper {
      position: absolute;
      opacity: 0;
      top: 0;
      left: 0;
      transition: opacity 0.3s ease-in-out;

      &.selected {
        opacity: 1;
      }
    }
  }
`;
